import { Controller, FieldError } from 'react-hook-form';
import React, { ReactNode } from 'react';

interface IProps {
  name: string;
  control: any;
  children: (fieldProps: {
    value: any;
    onChange: (...event: any[]) => void;
    onBlur: () => void;
    ref: any;
    error?: FieldError;
  }) => ReactNode;
}

export const ControllerWrapper: React.FC<IProps> = ({ name, control, children }) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => {
      const child = children({ value, onChange, onBlur, ref, error });
      if (React.isValidElement(child)) {
        return child;
      }
      return <div />; // return a default ReactElement instead of null
    }}
  />
);
